// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2YR0U","productName":"Table_productName__qGPCq"};